import { useRef } from "react";
import { Dialog } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import CenteredModal from "./CenteredModal";
import { classNames } from "../../helpers";
type AlertProps = {
  name?: string;
  isOpen: boolean;
  onClose: () => void;
  cancelBtnText?: string;
  returnBtnText?: string;
  className?: string;
  description?: string;
  setOpen: () => void;
};
export default function AlertModal(props: AlertProps) {
  const {
    name,
    isOpen,
    onClose,
    cancelBtnText,
    returnBtnText,
    className,
    description,
    setOpen,
  } = props;
  const LocalBasePath = "page.alert";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const cancelButtonRef = useRef(null);
  return (
    <CenteredModal setOpen={setOpen} open={isOpen}>
      <div className={classNames(!!className ? className : "sm:max-w-3xl")}>
        <div className="bg-white mb-3">
          <div className="sm:flex sm:items-start">
            <div className="w-full flex  flex-col">
              <Dialog.Title
                as="h3"
                className="text-sm flex  gap-3 font-medium  text-yellow-800"
              >
                <ExclamationIcon
                  className="h-6 w-6 text-yellow-400"
                  aria-hidden="true"
                />
                {t("payAttention")}
              </Dialog.Title>
              <div className="rtl:pr-8 mt-2 ltr:pl-8">
                <p
                  className={classNames(
                    " w-full flex  justify-start",
                    !!description
                      ? "text-base text-gray-500 "
                      : "text-sm text-gray-600 "
                  )}
                >
                  {!!description
                    ? description
                    : t("sessionConflict", { name: name ?? "" })}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 sm:flex gap-3 sm:flex-row-reverse">
          <button
            type="button"
            onClick={onClose}
            className={classNames(
              "w-full sm:w-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white  focus:outline-none focus:ring-2 focus:ring-offset-2",
              !!cancelBtnText
                ? "bg-red-600 hover:bg-red-700 focus:ring-red-500"
                : "bg-brandblue-600 hover:bg-brandblue-700 focus:ring-brandblue-500"
            )}
          >
            {!!cancelBtnText ? cancelBtnText : t("continue")}
          </button>
          <button
            type="button"
            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0  sm:w-auto"
            onClick={setOpen}
            ref={cancelButtonRef}
          >
            {!!returnBtnText ? returnBtnText : t("cancel")}
          </button>
        </div>
      </div>
    </CenteredModal>
  );
}
